<template>
    <div id="proHedaer">
        <a-form :form="proHedaerForm">
            <a-row>
                <a-col :span="12"><a-form-item label="Extenion Type" v-bind="formItemLayout">
                    <a-radio-group
                            disabled
                            size="small"
                            v-decorator="[
                              'geType',
                              {
                                  initialValue: proGenericHeaderInfo.geType

                              },
                            ]">
                        <a-radio value="O">Organization</a-radio>
                        <a-radio value="P">Project</a-radio>
                    </a-radio-group>
                </a-form-item></a-col>
                <a-col :span="12"><a-form-item label="Project" v-bind="formItemLayout">
                    <a-input size="small" disabled :value="proGenericHeaderInfo.projectName"/>
                </a-form-item></a-col>
                <a-col :span="12"><a-form-item label="Module" v-bind="formItemLayout">
                    <a-input size="small" disabled :value="proGenericHeaderInfo.subModuleCode"/>
                </a-form-item></a-col>
                <a-col :span="12"><a-form-item label="Function Code" v-bind="formItemLayout">
                    <a-input size="small" disabled :value="proGenericHeaderInfo.funcName"/>
                </a-form-item></a-col>
                <a-col :span="12"><a-form-item label="System Generic Name" v-bind="formItemLayout">
                    <a-input size="small" disabled :value="proGenericHeaderInfo.genericName"/>
                </a-form-item></a-col>
            </a-row>
        </a-form>
    </div>
</template>
<script>
    export default{
        props: {
            proGenericHeaderInfo: {
                type: Object,
                default: function () {
                    return {};
                }
            }
        },
        data(){
            return{
                formItemLayout: {
                    labelCol: {
                        xs: { span: 24 },
                        sm: { span: 8 }
                    },
                    wrapperCol: {
                        xs: { span: 24 },
                        sm: { span: 16 }
                    }
                },
                proHedaerForm: this.$form.createForm(this),
            }
        }
    }
</script>